/* Apple variant JS — reveals, LED switcher, 360 drag viewer, ATC.
   Loaded only by layout/theme.apple.liquid. */
(function () {
  'use strict';

  /* ---- Scroll reveals -------------------------------------------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Reuse each playback observer in two phases: fetch nearby, then play in view. */
  function armVideo(video) {
    if (video.hasAttribute('data-ap-media-armed')) return;
    video.setAttribute('data-ap-media-armed', '');
    video.querySelectorAll('source[data-ap-src]').forEach(function (source) {
      source.src = source.getAttribute('data-ap-src');
      source.removeAttribute('data-ap-src');
    });
    video.preload = 'auto';
    try { video.load(); } catch (e) {}
  }
  function observeVideoApproach(target, videos, onVisible, options) {
    var observer;
    function watch(near) {
      observer = new IntersectionObserver(function (entries) {
        if (near) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          (typeof videos === 'function' ? videos() : videos).forEach(armVideo);
          observer.disconnect();
          watch(false);
        } else {
          onVisible(entries);
        }
      }, near ? { rootMargin: '100% 0px', threshold: 0 } : options);
      observer.observe(target);
    }
    watch(true);
    return { disconnect: function () { observer.disconnect(); }, unobserve: function () { observer.disconnect(); } };
  }

  /* ---- Story animations: play once when in view, replay control below --- */
  (function storyAnims() {
    var stacks = document.querySelectorAll('[data-ap-story-anim]');
    if (!stacks.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    stacks.forEach(function (stack) {
      var v = stack.querySelector('[data-ap-story-video]');
      var replay = stack.querySelector('[data-ap-story-replay]');
      if (!v) return;
      var played = false;
      function play() {
        armVideo(v);
      v.muted = true;
        stack.classList.remove('is-done');
        var p = v.play();
        if (p && p.catch) p.catch(function () { stack.classList.add('is-done'); });
      }
      v.addEventListener('ended', function () {
        if (replay) replay.removeAttribute('hidden');
        stack.classList.add('is-done');
      });
      if (reduce) {
        /* no autoplay: leave the poster, offer the control instead */
        if (replay) replay.removeAttribute('hidden');
        stack.classList.add('is-done');
      } else if ('IntersectionObserver' in window) {
        /* 10-02 launch fix: on phones the stack can be taller than 60% of the viewport, so a 0.6 ratio was never
           reached and the animation never started (Ian: "not working on mobile"). Start when 60% is visible OR when
           the stack's middle band crosses the viewport's middle band. */
        var start = function () { if (played) return; played = true; try { io2.disconnect(); io3.disconnect(); } catch (e) {} play(); };
        var io2 = observeVideoApproach(stack, [v], function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio >= 0.6) start(); });
        }, { threshold: [0, 0.6] });
        var io3 = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) start(); });
        }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });
        io3.observe(stack);
      } else {
        played = true;
        play();
      }
      if (replay) {
        replay.addEventListener('click', function () {
          try { v.currentTime = 0; } catch (e) {}
          play();
          replay.blur();
        });
      }
    });
  })();

  /* ---- Valet phone: drop-in only once well in view, then play once ----- */
  (function valetPhone() {
    var phone = document.querySelector('.ap-valet__phone');
    var v = phone && phone.querySelector('[data-ap-valet-video]');
    if (!phone || !v) return;
    var replay = phone.querySelector('[data-ap-valet-replay]');
    var started = false, dropped = false;
    function play() {
      armVideo(v);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function start() {
      if (started) return;
      started = true;
      if (replay) replay.removeAttribute('hidden');
      play();
      // retry once in case the first call raced buffering
      setTimeout(function () { if (v.paused && !v.ended) play(); }, 350);
    }
    function drop() {
      if (dropped) return;
      dropped = true;
      phone.classList.add('is-drop');
      // Redundant play trigger keyed off the rise (matches the 1.8s settle),
      // independent of the animationend event ever firing.
      setTimeout(start, 1850);
    }
    v.addEventListener('ended', function () { phone.classList.add('is-vid-done'); });
    v.addEventListener('animationend', function (e) {
      if (e.animationName === 'ap-phone-drop') start();
    });

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      phone.classList.add('is-drop');
      start();
    } else if ('IntersectionObserver' in window) {
      // Fire only when ~70% of the card is in view, so the slide-up + play
      // happen where the user can actually see them.
      var io2 = observeVideoApproach(phone, [v], function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.7) { io2.unobserve(en.target); drop(); }
        });
      }, { threshold: [0, 0.7] });
      // Safety: if the card is too tall to ever hit 70% (short viewport), fire
      // once it's been at least partly on-screen for a while.
      setTimeout(function () {
        if (dropped) return;
        var r = phone.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9 && r.bottom > 0) drop();
      }, 6000);
    } else {
      drop();
    }

    if (replay) {
      replay.addEventListener('click', function () {
        phone.classList.remove('is-vid-done');
        replay.blur();
        // Restart from frame 0: pause, seek, and only play once the seek has landed
        // (play() right after setting currentTime can resume from the old position on some
        // engines). If the seek never reports back, reload the element — that always starts at 0.
        var played = false;
        function go() { if (played) return; played = true; v.removeEventListener('seeked', go); play(); }
        v.pause();
        v.addEventListener('seeked', go);
        try { v.currentTime = 0; } catch (e) {}
        setTimeout(function () {
          if (played) return;
          v.removeEventListener('seeked', go);
          played = true;
          try { v.load(); } catch (e) {}
          play();
        }, 400);
      });
    }
  })();

  /* ---- Dimension cards: phone carousel arrows (09-29) ------------------- */
  document.querySelectorAll('[data-ap-dims-nav]').forEach(function (nav) {
    var track = nav.previousElementSibling && nav.previousElementSibling.matches('[data-ap-dims]') ? nav.previousElementSibling : null;
    if (!track) return;
    var prev = nav.querySelector('[data-ap-dims-prev]'), next = nav.querySelector('[data-ap-dims-next]'), count = nav.querySelector('[data-ap-dims-count]');
    var cards = track.querySelectorAll('.ap-dim');
    function index() { return cards.length ? Math.round(track.scrollLeft / (track.clientWidth + 12)) : 0; }
    function sync() {
      var i = Math.max(0, Math.min(cards.length - 1, index()));
      if (count) count.textContent = (i + 1) + ' / ' + cards.length;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= cards.length - 1;
    }
    function go(d) {
      var i = Math.max(0, Math.min(cards.length - 1, index() + d));
      track.scrollTo({ left: i * (track.clientWidth + 12), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- Finish picker: label previews the hovered finish (09-29) -------- */
  (function finishHover() {
    var wrap = document.querySelector('[data-ap-finish]');
    var cur = wrap && wrap.querySelector('[data-ap-finish-current]');
    if (!wrap || !cur) return;
    wrap.querySelectorAll('.ap-finish__swatch').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () { cur.textContent = sw.getAttribute('title') || cur.dataset.current; });
      sw.addEventListener('mouseleave', function () { cur.textContent = cur.dataset.current; });
    });
  })();

  /* ---- LED swatch picker ----------------------------------------------- */
  var swatches = document.querySelectorAll('[data-ap-led]');
  var ledImgs = document.querySelectorAll('[data-ap-led-img]');
  function preloadLEDs() {
    ledImgs.forEach(function (img) { img.loading = 'eager'; });
  }
  if (ledImgs.length && 'IntersectionObserver' in window) {
    var ledIo = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) { preloadLEDs(); ledIo.disconnect(); }
    }, { rootMargin: '100% 0px' });
    ledIo.observe(ledImgs[0].closest('.ap-led') || ledImgs[0]);
  }
  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      preloadLEDs();
      var key = btn.getAttribute('data-ap-led');
      ledImgs.forEach(function (img) {
        var on = img.getAttribute('data-ap-led-img') === key;
        if (on) {
          img.classList.remove('is-prev');
          img.classList.add('is-active');
        } else if (img.classList.contains('is-active')) {
          /* outgoing frame stays fully opaque underneath while the new one fades in on top
             → the composite is never < 100% opaque, so the stage bg can't flash through */
          img.classList.remove('is-active');
          img.classList.add('is-prev');
        }
      });
      window.setTimeout(function () {
        ledImgs.forEach(function (img) { if (!img.classList.contains('is-active')) img.classList.remove('is-prev'); });
      }, 620);
      swatches.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---- What's Included showcase (ledger + thumbs + stage) -------------- */
  (function inclShowcase() {
    var wrap = document.querySelector('[data-ap-incl]');
    if (!wrap) return;
    var items = wrap.querySelectorAll('[data-ap-incl-item]');
    var imgs = wrap.querySelectorAll('[data-ap-incl-img]');
    var mcap = wrap.querySelector('[data-ap-incl-mcap]');
    var stageEl = wrap.querySelector('[data-ap-incl-stage]');
    var vids = wrap.querySelectorAll('[data-ap-incl-video]');
    var replayBtn = wrap.querySelector('[data-ap-incl-replay]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeVid = null;
    /* The first item's clip used to start on page load, so by the time the visitor scrolled
       to the section it had already finished (final frame only). Hold playback until the
       stage is roughly centred in the viewport, then start from frame 0. Clicks still play at once. */
    var armed = false;
    function clearDone() { if (stageEl) stageEl.classList.remove('is-vid-done', 'is-box-done'); }
    function activate(idx) {
      items.forEach(function (b) {
        var on = b.getAttribute('data-ap-incl-item') === idx;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && mcap) {
          var name = b.querySelector('.ap-incl__name');
          var desc = b.querySelector('.ap-incl__desc');
          mcap.textContent = '';
          var strong = document.createElement('strong');
          strong.textContent = name ? name.textContent : '';
          mcap.appendChild(strong);
          if (desc) mcap.appendChild(document.createTextNode(' — ' + desc.textContent));
        }
      });
      clearDone();
      /* arm the matching final-frame callout for this item (revealed on video end) */
      wrap.querySelectorAll('[data-ap-incl-callout-for]').forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-ap-incl-callout-for') === idx);
      });
      activeVid = null;
      imgs.forEach(function (el) {
        var on = el.getAttribute('data-ap-incl-img') === idx;
        el.classList.toggle('is-active', on);
        if (el.tagName === 'VIDEO') {
          if (on) {
            activeVid = el;
            if (armed) armVideo(el);
            if (reduce) { try { el.currentTime = Math.max(0, el.duration - 0.05); } catch (e) {} }
            else if (!armed) { try { el.currentTime = 0; el.pause(); } catch (e) {} }
            else { try { el.currentTime = 0; el.playbackRate = 0.5; el.play().catch(function () {}); } catch (e) {} }
          } else {
            try { el.pause(); } catch (e) {}
          }
        }
      });
      if (replayBtn) { if (activeVid) replayBtn.removeAttribute('hidden'); else replayBtn.setAttribute('hidden', ''); }
    }
    function resume(v) {
      if (v === activeVid && !v.ended && !reduce && armed) {
        try { v.playbackRate = 0.5; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
    }
    vids.forEach(function (v) {
      v.addEventListener('ended', function () {
        if (v !== activeVid || !stageEl) return;
        stageEl.classList.add('is-vid-done');
        if (v.hasAttribute('data-ap-incl-callout')) stageEl.classList.add('is-box-done');
      });
      // recover from buffer stalls / unexpected pauses so the clip always plays to the end
      v.addEventListener('waiting', function () { resume(v); });
      v.addEventListener('stalled', function () { resume(v); });
      v.addEventListener('pause', function () { resume(v); });
    });
    if (replayBtn) replayBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!activeVid) return;
      clearDone();
      armVideo(activeVid);
      try { activeVid.currentTime = 0; activeVid.playbackRate = 0.5; activeVid.play().catch(function () {}); } catch (e2) {}
      replayBtn.blur();
    });
    items.forEach(function (b) {
      b.addEventListener('click', function () { armed = true; activate(b.getAttribute('data-ap-incl-item')); });
    });
    if (stageEl && 'IntersectionObserver' in window && !reduce) {
      /* ~50% of the stage in view (less when the stage is taller than the viewport) */
      var th = Math.max(0.2, Math.min(0.5, (window.innerHeight * 0.6) / Math.max(1, stageEl.offsetHeight)));
      var armIo = observeVideoApproach(stageEl, function () { return activeVid ? [activeVid] : []; }, function (entries) {
        entries.forEach(function (en) {
          if (!armed && en.isIntersecting && en.intersectionRatio >= th) {
            armed = true;
            armIo.disconnect();
            if (activeVid) { armVideo(activeVid); try { activeVid.currentTime = 0; activeVid.playbackRate = 0.5; activeVid.play().catch(function () {}); } catch (e) {} }
          }
        });
      }, { threshold: [0, th] });
    } else {
      armed = true;
    }
    if (items.length) activate(items[0].getAttribute('data-ap-incl-item'));
  })();

  /* ---- 360 drag viewer ------------------------------------------------- */
  var stage = document.querySelector('[data-ap-360]');
  if (stage) {
    var mobileFrames = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    var framesScript = document.getElementById(mobileFrames ? 'ap-360-frames-mobile' : 'ap-360-frames') || document.getElementById('ap-360-frames');
    var frames = [];
    try { frames = JSON.parse(framesScript.textContent); } catch (e) { frames = []; }

    if (frames.length) {
      var viewImg = stage.querySelector('img');
      var current = (parseInt(stage.getAttribute('data-ap-360-start'), 10) || 1) - 1;
      if (current < 0 || current >= frames.length) current = 0;
      var requested = current, loaded = {}, pending = {}, preloaded = false;
      var queue = [], inFlight = 0;
      /* The initial lazy image remains visible while the sparse rotation fills in. */
      function markInitial() {
        if (viewImg.naturalWidth) { loaded[current] = true; }
      }
      if (viewImg.complete) markInitial();
      else viewImg.addEventListener('load', markInitial, { once: true });
      function pump() {
        while (inFlight < 2 && queue.length) {
          var index = queue.shift();
          if (loaded[index] || pending[index]) continue;
          loadFrame(index);
        }
      }
      function loadFrame(index) {
        pending[index] = true;
        inFlight++;
        var pre = new Image();
        pre.onload = function () {
          loaded[index] = true;
          finish();
          setFrame(requested);
        };
        pre.onerror = finish;
        function finish() { delete pending[index]; inFlight--; pump(); }
        pre.src = frames[index];
      }
      var preload = function () {
        if (preloaded) return;
        preloaded = true;
        /* A usable full rotation first, then the intervening frames; at most two downloads. */
        for (var i = 0; i < frames.length; i += 4) queue.push((current + i) % frames.length);
        for (var j = 0; j < frames.length; j++) {
          if (j % 4) queue.push((current + j) % frames.length);
        }
        pump();
      };
      if ('IntersectionObserver' in window) {
        var preIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { preload(); preIo.disconnect(); }
          });
        }, { rootMargin: '150% 0px' });
        preIo.observe(stage.closest('.ap-360') || stage);
      } else {
        preload();
      }

      var hotspots = Array.prototype.slice.call(stage.querySelectorAll('[data-ap-hs]'));
      var updateHotspots = function () {
        var f = current + 1;
        hotspots.forEach(function (hs) {
          var a = Number(hs.getAttribute('data-frame-start'));
          var b = Number(hs.getAttribute('data-frame-end'));
          var active = a <= b ? (f >= a && f <= b) : (f >= a || f <= b);
          hs.classList.toggle('is-active', active);
          if (!active) hs.classList.remove('is-open');
        });
      };
      hotspots.forEach(function (hs) {
        var dot = hs.querySelector('.ap-hs__dot');
        dot.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          var wasOpen = hs.classList.contains('is-open');
          hotspots.forEach(function (h) { h.classList.remove('is-open'); });
          if (!wasOpen) hs.classList.add('is-open');
        });
      });
      updateHotspots();

      var setFrame = function (index) {
        var n = frames.length;
        requested = ((index % n) + n) % n;
        var next = requested;
        if (!loaded[next]) {
          /* Circular distance keeps drag responsive without replacing the image with an unloaded URL. */
          for (var distance = 1; distance <= Math.floor(n / 2); distance++) {
            var before = (requested - distance + n) % n, after = (requested + distance) % n;
            if (loaded[before]) { next = before; break; }
            if (loaded[after]) { next = after; break; }
          }
        }
        if (!loaded[next] || next === current) return;
        current = next;
        var mobileSource = stage.querySelector('[data-ap-360-source]');
        if (mobileSource) mobileSource.srcset = frames[current];
        viewImg.removeAttribute('srcset');
        viewImg.src = frames[current];
        updateHotspots();
        var counter = document.querySelector('[data-ap-360-counter]');
        if (counter) counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + n;
      };

      var dragging = false, startX = 0, startFrame = 0;
      var PX_PER_FRAME = 12;

      stage.addEventListener('pointerdown', function (e) {
        preload();
        hotspots.forEach(function (h) { h.classList.remove('is-open'); });
        dragging = true;
        startX = e.clientX;
        startFrame = current;
        stage.classList.add('is-dragging');
        stage.setPointerCapture(e.pointerId);
      });
      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = Math.round((e.clientX - startX) / PX_PER_FRAME);
        setFrame(startFrame - delta);
      });
      var endDrag = function () { dragging = false; stage.classList.remove('is-dragging'); };
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
    }
  }

  /* ---- Complete Your Humidor add-on drawer ---------------------------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function apSelectedAddons() {
    var out = [];
    document.querySelectorAll('[data-ap-addon]:checked').forEach(function (i) {
      var id = Number(i.getAttribute('data-addon-id'));
      if (!id) return;
      var plan = i.getAttribute('data-addon-selling-plan');
      var item = { id: id, quantity: 1 };
      if (plan) item.selling_plan = Number(plan);
      out.push(item);
    });
    return out;
  }
  function apAddonPriceTotal() {
    var t = 0;
    document.querySelectorAll('[data-ap-addon]:checked').forEach(function (i) { t += parseInt(i.getAttribute('data-addon-price'), 10) || 0; });
    return t;
  }
  function apRefreshAtcTotal() {
    var btn = document.querySelector('[data-ap-atc-total]');
    if (!btn || btn.disabled) return;
    var base = parseInt(btn.getAttribute('data-base-price'), 10) || 0;
    var label = btn.querySelector('[data-ap-atc-label]');
    if (label) label.textContent = 'Add to Bag';
  }
  function apBuildItems(form) {
    var q = form.querySelector('[name="quantity"]');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var items = [{ id: Number(form.querySelector('[name="id"]').value), quantity: qty }];
    if (form.querySelector('[data-ap-atc-total]')) apSelectedAddons().forEach(function (a) { items.push(a); });
    return items;
  }
  (function () {
    var toggle = document.querySelector('[data-ap-addons-toggle]');
    var body = document.querySelector('[data-ap-addons-body]');
    if (toggle && body) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') !== 'false';
        toggle.setAttribute('aria-expanded', String(!expanded));
        body.hidden = expanded;
      });
    }
    document.querySelectorAll('[data-ap-addon]').forEach(function (input) {
      input.addEventListener('change', function () {
        var card = input.closest('.ap-addon');
        if (card) card.classList.toggle('is-selected', input.checked);
        apRefreshAtcTotal();
      });
    });
  })();

  /* ---- Add to cart ----------------------------------------------------- */
  /* 10-01 (Ian): hero + ribbon "Add to Bag" add the unit (and ticked add-ons) via the buybox form instead of scrolling */
  document.querySelectorAll('[data-ap-buy-trigger]').forEach(function (trig) {
    trig.addEventListener('click', function (e) {
      var form = document.querySelector('[data-ap-atc-form]');
      var btn = form ? form.querySelector('[data-ap-atc]') : null;
      if (!form || !btn || btn.disabled) return; /* no form / sold out / mid-add -> fall through to #ap-buy */
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      var label = trig.querySelector('[data-ap-atc-label]');
      trig.classList.add('is-added');
    });
  });
  document.querySelectorAll('[data-ap-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-ap-atc]');
      var label = btn ? btn.querySelector('[data-ap-atc-label]') : null;
      var original = label ? label.textContent : '';
      if (label) label.textContent = 'Adding…';
      if (btn) btn.disabled = true;

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: apBuildItems(form) }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          if (label) label.textContent = 'Added — View Bag';
          if (btn) {
            btn.disabled = false;
            btn.addEventListener('click', function (ev) {
              ev.preventDefault();
              window.location.href = window.routes.cart_url;
            });
          }
        })
        .catch(function () {
          if (label) label.textContent = original;
          if (btn) btn.disabled = false;
          form.submit();
        });
    });
  });

  /* ---- Sync all variant selects + ATC labels --------------------------- */
  var selects = document.querySelectorAll('[data-ap-variant]');
  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      selects.forEach(function (other) { if (other !== sel) other.value = sel.value; });
    });
  });

  /* ---- Buybox gallery -------------------------------------------------- */
  var galleryMain = document.querySelector('[data-ap-gallery-main]');
  var thumbs = document.querySelectorAll('[data-ap-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-ap-thumb');
      if (!galleryMain || !src) return;
      galleryMain.src = src;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---- Quantity steppers ---------------------------------------------- */
  document.querySelectorAll('[data-ap-qty-input]').forEach(function (input) {
    var wrap = input.closest('form') || input.parentNode;
    var minus = wrap.querySelector('[data-ap-qty-minus]');
    var plus = wrap.querySelector('[data-ap-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    input.addEventListener('change', function () { var v = parseInt(input.value, 10); input.value = (isNaN(v) || v < 1) ? 1 : v; });
  });

  /* ---- Cross-sell add-to-cart ----------------------------------------- */
  document.querySelectorAll('[data-ap-xadd]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = Number(btn.getAttribute('data-variant-id'));
      var label = btn.querySelector('[data-ap-xadd-label]');
      var original = label ? label.textContent : '';
      if (!id) return;
      var plan = btn.getAttribute('data-selling-plan');
      var item = { id: id, quantity: 1 };
      if (plan) item.selling_plan = Number(plan);
      if (label) label.textContent = 'Adding…';
      btn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); if (label) label.textContent = 'Added ✓'; btn.disabled = false; })
        .catch(function () { if (label) label.textContent = original; btn.disabled = false; });
    });
  });

  /* ---- Image zoom lightbox -------------------------------------------- */
  (function () {
    var main = document.querySelector('[data-ap-gallery-main]');
    if (!main) return;
    var thumbEls = Array.prototype.slice.call(document.querySelectorAll('[data-ap-thumb]'));
    var imgs = thumbEls.length ? thumbEls.map(function (t) { return t.getAttribute('data-ap-thumb'); }) : [main.src];
    var idx = 0, zoomed = false;

    var ov = document.createElement('div');
    ov.className = 'zoombox';
    ov.setAttribute('hidden', '');
    ov.innerHTML =
      '<button class="zoombox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="zoombox__nav zoombox__nav--prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<figure class="zoombox__stage"><img class="zoombox__img" alt=""></figure>' +
      '<button class="zoombox__nav zoombox__nav--next" type="button" aria-label="Next">&#8250;</button>' +
      '<span class="zoombox__counter"></span>';
    document.body.appendChild(ov);
    var boxImg = ov.querySelector('.zoombox__img');
    var counter = ov.querySelector('.zoombox__counter');
    var stage = ov.querySelector('.zoombox__stage');
    if (imgs.length < 2) { ov.querySelector('.zoombox__nav--prev').style.display = 'none'; ov.querySelector('.zoombox__nav--next').style.display = 'none'; counter.style.display = 'none'; }

    var render = function () { boxImg.src = imgs[idx]; counter.textContent = (idx + 1) + ' / ' + imgs.length; zoomed = false; boxImg.classList.remove('is-zoomed'); boxImg.style.transform = ''; };
    var open = function (i) { idx = i || 0; render(); ov.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; };
    var close = function () { ov.setAttribute('hidden', ''); document.body.style.overflow = ''; };
    var next = function () { idx = (idx + 1) % imgs.length; render(); };
    var prev = function () { idx = (idx - 1 + imgs.length) % imgs.length; render(); };

    main.style.cursor = 'zoom-in';
    main.addEventListener('click', function () {
      var active = document.querySelector('[data-ap-thumb].is-active');
      var start = 0;
      if (active) thumbEls.forEach(function (t, i) { if (t === active) start = i; });
      open(start);
    });
    ov.querySelector('.zoombox__close').addEventListener('click', close);
    ov.querySelector('.zoombox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); next(); });
    ov.querySelector('.zoombox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target === stage) close(); });
    boxImg.addEventListener('click', function (e) { e.stopPropagation(); zoomed = !zoomed; boxImg.classList.toggle('is-zoomed', zoomed); if (!zoomed) boxImg.style.transform = ''; });
    stage.addEventListener('mousemove', function (e) { if (!zoomed) return; var r = boxImg.getBoundingClientRect(); boxImg.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%'; });
    document.addEventListener('keydown', function (e) { if (ov.hasAttribute('hidden')) return; if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') next(); else if (e.key === 'ArrowLeft') prev(); });
  })();

  /* ---- Intro reveal curtain ------------------------------------------- */
  (function () {
    var curtain = document.querySelector('[data-ap-intro]');
    if (!curtain) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = false;
    try { seen = sessionStorage.getItem('apIntroSeen') === '1'; } catch (e) {}
    if (reduce || seen) { curtain.classList.add('is-skip'); return; }
    try { sessionStorage.setItem('apIntroSeen', '1'); } catch (e) {}
    document.body.style.overflow = 'hidden';
    var cleanup = function () { curtain.classList.add('is-skip'); document.body.style.overflow = ''; };
    curtain.addEventListener('animationend', function (e) { if (e.animationName === 'apIntroOut') cleanup(); });
    setTimeout(cleanup, 4200);
  })();

  /* ---- Info tabs ------------------------------------------------------- */
  document.querySelectorAll('[data-ap-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-ap-tab]');
    var rows = tabs.querySelectorAll('[data-ap-tab-row]');   // phone disclosure rows (09-29)
    var panels = tabs.querySelectorAll('[data-ap-tab-panel]');
    function activate(key) {   // key === null collapses everything (phones: tapping the open row)
      buttons.forEach(function (b) { var on = b.getAttribute('data-ap-tab') === key; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
      rows.forEach(function (r) { r.setAttribute('aria-expanded', String(r.getAttribute('data-ap-tab-row') === key)); });
      panels.forEach(function (p) { var on = p.getAttribute('data-ap-tab-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn.getAttribute('data-ap-tab')); });
    });
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var key = row.getAttribute('data-ap-tab-row');
        activate(row.getAttribute('aria-expanded') === 'true' ? null : key);
      });
    });
  });

  /* ---- Solution subscription variant select --------------------------- */
  document.querySelectorAll('[data-ap-solution-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var addon = sel.closest('.ap-addon');
      var input = addon ? addon.querySelector('[data-ap-addon]') : null;
      if (!input) return;
      var opt = sel.options[sel.selectedIndex];
      input.setAttribute('data-addon-id', opt.value);
      input.setAttribute('data-addon-price', opt.getAttribute('data-price') || input.getAttribute('data-addon-price'));
      apRefreshAtcTotal();
    });
  });

  /* ---- Smooth-scroll anchors ------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Save / bookmark toggle (self-contained, localStorage) ------------ */
  var saveBtn = document.querySelector('[data-ap-save]');
  if (saveBtn) {
    var saveKey = 'ap-saved-' + saveBtn.getAttribute('data-ap-save');
    var isSaved = false;
    try { isSaved = localStorage.getItem(saveKey) === '1'; } catch (e) {}
    saveBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    saveBtn.addEventListener('click', function () {
      isSaved = saveBtn.getAttribute('aria-pressed') !== 'true';
      saveBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      try { isSaved ? localStorage.setItem(saveKey, '1') : localStorage.removeItem(saveKey); } catch (e) {}
    });
  }

  /* ---- Hero intro animation (video plays once, replay appears on hover) -- */
  (function heroVideo() {
    var section = document.querySelector('[data-ap-hero-play]');
    if (!section) return;
    var video = section.querySelector('[data-ap-hero-video]');
    var replayBtn = section.querySelector('[data-ap-hero-replay]');
    if (!video) return;
    var started = false, settled = false, playResolved = false, hasPlayed = false;
    var attempt = 0, startTimer, deadline;
    function showReplay() { if (replayBtn) replayBtn.removeAttribute('hidden'); }
    function seekEnd() {
      if (settled && isFinite(video.duration) && video.duration > 0) {
        try { video.currentTime = Math.max(0, video.duration - 0.05); } catch (e) {}
      }
    }
    /* Only an explicit playback failure or reduced motion may skip the intro. */
    function restEnd() {
      started = settled = true;
      attempt++;
      clearTimeout(startTimer);
      clearTimeout(deadline);
      try { video.pause(); } catch (e) {}
      section.classList.remove('is-rest', 'is-hero-playing');
      section.classList.add('is-done');
      showReplay();
      seekEnd();
    }
    video.addEventListener('loadedmetadata', function () { if (settled && !video.ended) seekEnd(); });
    video.addEventListener('ended', function () {
      settled = true;
      clearTimeout(deadline);
      section.classList.add('is-done');
      showReplay();
    });
    video.addEventListener('playing', function () {
      if (settled) return;
      hasPlayed = true;
      clearTimeout(deadline);
      section.classList.remove('is-rest', 'is-done');
      section.classList.add('is-hero-playing');
      showReplay();
    });
    video.addEventListener('error', restEnd);

    function curtainUp() {
      var c = document.querySelector('[data-ap-intro]');
      return !!(c && !c.classList.contains('is-skip'));
    }
    function play() {
      started = true;
      var thisAttempt = ++attempt;
      showReplay();
      try {
        video.muted = true;
        var p = video.play();
        if (p && p.then) p.then(function () {
          if (attempt === thisAttempt) playResolved = true;
        }, function () {
          if (attempt === thisAttempt) restEnd();
        });
      } catch (e) { restEnd(); }
    }
    function maybeStart() {
      if (started || settled || startTimer || document.hidden || curtainUp()) return;
      /* play() initiates loading when Safari declines to preload. Waiting for readyState
         first can deadlock autoplay; its pending promise already waits for media data. */
      startTimer = setTimeout(function () {
        startTimer = null;
        if (!started && !settled && !document.hidden && !curtainUp()) play();
      }, 400);
    }
    if (replayBtn) {
      replayBtn.addEventListener('click', function () {
        clearTimeout(startTimer);
        clearTimeout(deadline);
        settled = playResolved = hasPlayed = false;
        section.classList.remove('is-done', 'is-rest', 'is-hero-playing');
        try { video.currentTime = 0; } catch (e) {}
        play();
        replayBtn.blur();
      });
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      restEnd();
      return;
    }
    setTimeout(function () { if (!hasPlayed && !settled) section.classList.add('is-rest'); }, 3000);
    deadline = setTimeout(function () {
      /* Reveal the product copy and replay control, but do not cancel a pending
         play() or seek past an intro just because the browser is still loading. */
      if (!settled && !hasPlayed) {
        section.classList.add('is-rest', 'is-done');
        showReplay();
      }
    }, 30000);
    ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (ev) { video.addEventListener(ev, maybeStart); });
    document.addEventListener('visibilitychange', maybeStart);
    if (curtainUp()) {
      document.querySelector('[data-ap-intro]').addEventListener('animationend', function () { setTimeout(maybeStart, 60); });
    }
    setTimeout(maybeStart, 5000); /* retry after the curtain's own fallback, without bypassing visibility */
    maybeStart();
  })();
  /* Dimensions cards: click-to-zoom lightbox */
  (function dimZoom() {
    var lb = document.querySelector('[data-ap-lightbox]');
    if (!lb) return;
    var lbImg = lb.querySelector('[data-ap-lb-img]');
    var lbLabel = lb.querySelector('[data-ap-lb-label]');
    var lbDims = lb.querySelector('[data-ap-lb-dims]');
    function openRaw(src, labelText, dimsText) {
      if (!src) return;
      lbImg.src = src;
      lbImg.alt = labelText || '';
      lbLabel.textContent = labelText || '';
      lbDims.textContent = dimsText || '';
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function open(card) {
      var img = card && card.querySelector('.ap-dim__media img');
      if (!img) return;
      var label = card.querySelector('.ap-dim__label');
      var dims = card.querySelector('.ap-dim__dims');
      openRaw(img.src || img.currentSrc, label ? label.textContent : '', dims ? dims.textContent : '');
    }
    /* buybox gallery main image zooms through the same lightbox */
    var gMain = document.querySelector('[data-ap-gallery-main]');
    if (gMain) {
      gMain.addEventListener('click', function () {
        openRaw(gMain.currentSrc || gMain.src, gMain.alt || '', '');
      });
    }
    /* What's Included stage zooms through the same lightbox */
    var inclStage = document.querySelector('[data-ap-incl-stage]');
    if (inclStage) {
      inclStage.addEventListener('click', function () {
        var img = inclStage.querySelector('img.is-active');
        if (img) openRaw(img.src || img.currentSrc, img.alt || '', '');
      });
    }
    function close() {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
    }
    document.querySelectorAll('[data-ap-dim-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn.closest('.ap-dim')); });
    });
    lb.querySelectorAll('[data-ap-lb-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  })();

  /* ---- Main nav mobile menu ------------------------------------------- */
  (function mainNavMenu() {
    var burger = document.querySelector('[data-ap-burger]');
    var sheet = document.querySelector('[data-ap-mobile-menu]');
    if (!burger || !sheet) return;
    function setOpen(open) {
      if (open) sheet.removeAttribute('hidden');
      else sheet.setAttribute('hidden', '');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.classList.toggle('is-open', open);
    }
    burger.addEventListener('click', function () { setOpen(sheet.hasAttribute('hidden')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hasAttribute('hidden')) setOpen(false); });
  })();

  /* ---- Swipe rows (accessories, gallery thumbs): arrows page a full width */
  (function scrollRows() {
    function attach(scroller, prev, next, count) {
      if (!scroller || !prev || !next) return;
      var narrow = function () { return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; };
      function cardStep() {   // one card + gap (phones page one card at a time; desktop pages a full width)
        var first = scroller.firstElementChild;
        if (!first) return scroller.clientWidth;
        var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function step() {
        if (narrow()) return cardStep();
        var cs = getComputedStyle(scroller);
        return scroller.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      }
      function update() {
        var over = scroller.scrollWidth > scroller.clientWidth + 4;
        prev.hidden = !over || scroller.scrollLeft <= 4;
        next.hidden = !over || scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 4;
        if (count) {
          var n = scroller.children.length, i = Math.min(n - 1, Math.max(0, Math.round(scroller.scrollLeft / cardStep())));
          count.textContent = n ? (i + 1) + ' / ' + n : '';
        }
      }
      prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    attach(document.querySelector('[data-ap-rel-scroller]'), document.querySelector('[data-ap-rel-prev]'), document.querySelector('[data-ap-rel-next]'), document.querySelector('[data-ap-rel-count]'));
    attach(document.querySelector('[data-ap-thumb-scroller]'), document.querySelector('[data-ap-thumb-prev]'), document.querySelector('[data-ap-thumb-next]'));
  })();

  /* ---- Scroll-up reveals the main site bar ----------------------------- */
  (function navReveal() {
    var mainbar = document.querySelector('.ap-mainnav');
    if (!mainbar) return;
    var wrapper = mainbar.parentElement;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (y <= mainbar.offsetHeight) {
        wrapper.classList.remove('ap-nav--revealed');
      } else if (y < lastY - 4) {
        wrapper.classList.add('ap-nav--revealed');
      } else if (y > lastY + 4) {
        wrapper.classList.remove('ap-nav--revealed');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  })();
})();
